import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Sad(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M4 12a8 8 0 1116 0 8 8 0 01-16 0zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM9 9a1 1 0 000 2h.01a1 1 0 100-2H9zm5 1a1 1 0 011-1h.01a1 1 0 110 2H15a1 1 0 01-1-1zm-6.53 6.848a1 1 0 001.373-.31c.192-.288.46-.535.732-.742C10.093 15.4 10.885 15 12 15c1.114 0 1.907.4 2.425.796.272.207.54.454.731.741a1 1 0 001.691-1.068v-.001l-.002-.002c-.353-.476-.731-.898-1.208-1.261C14.842 13.598 13.635 13 12 13c-1.635 0-2.842.6-3.637 1.204-.458.35-.902.774-1.21 1.266a1 1 0 00.317 1.378z",
    clipRule: "evenodd"
  }));
}

export default Sad;